import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoaderState } from '../model/loader-state.model';

/**
 * * Serviço para o componente de Loader.
 */
@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private readonly loaderSubject = new BehaviorSubject<LoaderState>({show: false, message: null});

  constructor() { }

  /**
   * * Mostrar Loader.
   * @param message mensagem a ser exibida
   */
  public show(message: string | null = null): void {
    this.doNext(true, message);
  }

  /**
   * * Esconder loader.
   */
  public hide(): void {
    this.doNext(false);
  }

  private doNext(show: boolean, message: string | null = null): void {
    this.loaderSubject.next({show, message});
  }

  public getLoader(): BehaviorSubject<LoaderState> {
    return this.loaderSubject;
  }
}
